import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBuilding as Building } from 'react-icons/fa';
import { FiPhone as Phone } from 'react-icons/fi';
import Logo from '../common/Logo';
import { AGENCY_PHONE_DISPLAY } from '../constants/contact';

const Footer = () => {
  const navigate = useNavigate();
  const goToQuote = () => navigate('/quote');

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="mb-6">
              <Logo className="h-10 w-auto brightness-0 invert" textColor="text-white" />
            </div>
            <p className="text-gray-400 mb-4">
              Serving the Filipino-American community with honest, expert insurance guidance since 1993.
            </p>
            <div className="text-sm text-gray-500">
              <div>17304 Norwalk Blvd, Cerritos, CA 90703</div>
              <div>{AGENCY_PHONE_DISPLAY}</div>
              <div>Monday - Friday: 9 AM - 6 PM</div>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2 text-gray-400">
              <div><a href="/services" className="hover:text-white transition-colors">Services</a></div>
              <div><a href="/about" className="hover:text-white transition-colors">About Us</a></div>
              <div><a href="/contact" className="hover:text-white transition-colors">Contact</a></div>
              <div><a href="/login" className="hover:text-white transition-colors">Client Login</a></div>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Connect</h4>
            <div className="space-y-2 text-gray-400">
              <div>info@pinoygeneralinsurance.com</div>
              <div className="pt-4">
                <button
                  onClick={goToQuote}
                  className="bg-[#DC143C] text-white px-6 py-2 rounded-lg font-semibold hover:bg-[#B01030] transition-all duration-200"
                >
                  Get Free Quote
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Pinoy General Insurance Services. All rights reserved. Licensed in California.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
